var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItalic = function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "M18.55 11.266h-.033l-.01.032-3.126 9.375-.02.061h1.889a.89.89 0 0 1 0 1.782H11a.89.89 0 0 1 0-1.782h2.483l.01-.032 3.126-9.375.02-.061H14.75a.89.89 0 0 1 0-1.782H21a.89.89 0 0 1 0 1.782h-2.45Z"
  })));
};
export default SvgItalic;